import { useMutation } from "react-query";
import Api, { IApi } from "../../services/Api";
import {
  DossierParticulier,
  SituationPersonnelleDossierParticulier,
} from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const usePostSituationPersonnellePrincipal = () => {
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<
    DossierParticulier,
    any,
    {
      dossierLocationRef?: string;
      principal: SituationPersonnelleDossierParticulier;
      prefixe: string;
    }
  >(
    // @ts-ignore
    (params: {
      dossierLocationRef?: string;
      principal: SituationPersonnelleDossierParticulier;
      prefixe: string;
    }) =>
      (api &&
        params.dossierLocationRef &&
        api.postSituationPersonnelle({
          dossierLocationRef: params.dossierLocationRef,
          situationPersonnelle: params.principal,
        })) ||
      undefined
  );
};

export const usePutSituationPersonnellePrincipal = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<
    DossierParticulier,
    any,
    {
      dossierLocationRef?: string;
      principal: SituationPersonnelleDossierParticulier;
      reference: string;
      prefixe: string;
    }
  >(
    // @ts-ignore
    (params: {
      dossierLocationRef?: string;
      principal: SituationPersonnelleDossierParticulier;
      reference: string;
      prefixe: string;
    }) =>
      (api &&
        params.dossierLocationRef &&
        api.putSituationPersonnelle({
          dossierLocationRef: params.dossierLocationRef,
          dossierPersonneRef: params.reference,
          situationPersonnelle: params.principal,
        })) ||
      undefined
  );
};

export const usePutSituationPersonnelleSecondaire = () => {
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<
    DossierParticulier,
    any,
    {
      dossierLocationRef?: string;
      situationPersonnelle?: SituationPersonnelleDossierParticulier;
      reference: string;
    }
  >(
    // @ts-ignore
    (params: {
      dossierLocationRef?: string;
      situationPersonnelle: SituationPersonnelleDossierParticulier;
      reference: string;
    }) =>
      (api &&
        params.dossierLocationRef &&
        api.putSituationPersonnelle({
          dossierLocationRef: params.dossierLocationRef,
          dossierPersonneRef: params.reference,
          situationPersonnelle: params.situationPersonnelle,
        })) ||
      undefined
  );
};
